import { reactive } from 'vue';

// How many app shells are mounted: a signed-in page renders in one, and the
// shell is what brings the phone bottom nav. The install banner reads it to
// sit clear of that nav (the login, error and display pages have no shell).
export const appShellState = reactive({ count: 0 });
